import { useEffect } from "react";

import { computeBidders } from "./bids";
import {
  VideoLinearity,
  VideoPlacement,
  VideoPlacementV2,
  VideoPlaybackMethod,
  VideoProtocol,
  VideoSkip,
} from "./enums";

export const useRenderSlot = (slot: googletag.Slot | null) => {
  useEffect(() => {
    if (!slot) return;

    const adUnit: pbjs.AdUnit = {
      bids: computeBidders(),
      code: slot.getSlotElementId(),
      mediaTypes: {
        banner: {
          sizes: [
            [300, 250],
            [1, 1],
          ],
        },
        video: {
          api: [],
          context: "outstream",
          h: 480,
          linearity: VideoLinearity.NonLinear,
          maxduration: 30,
          mimes: [
            "video/webm",
            "application/javascript",
            "video/mp4",
            "application/x-mpeg",
            "application/x-mpegURL",
          ],
          placement: VideoPlacement.InArticle,
          playbackmethod: [VideoPlaybackMethod.PageLoadWithSoundOff],
          playerSize: [640, 480],
          plcmt: VideoPlacementV2.NoContentOrStandalone,
          protocols: [
            VideoProtocol.VAST1,
            VideoProtocol.VAST2,
            VideoProtocol.VAST3,
            VideoProtocol.VAST1Wrapper,
            VideoProtocol.VAST2Wrapper,
            VideoProtocol.VAST3Wrapper,
            VideoProtocol.VAST4,
            VideoProtocol.VAST4Wrapper,
          ],
          skip: VideoSkip.Yes,
          w: 640,
        },
      },
    };

    pbjs.que.push(async () => {
      pbjs.addAdUnits(adUnit);
      await pbjs.requestBids({ adUnitCodes: [adUnit.code] });
      pbjs.setTargetingForGPTAsync([adUnit.code]);
      googletag.cmd.push(() => {
        googletag.display(slot);
        googletag.pubads().refresh([slot]);
      });
    });

    return () => {
      pbjs.que.push(() => {
        pbjs.removeAdUnit([adUnit.code]);
      });
    };
  }, [slot]);
};
